import Bug from '../../../../../images/jira-icons/bug.svg';
import Epic from '../../../../../images/jira-icons/epic.svg';
import Improvement from '../../../../../images/jira-icons/jira_improvement.png';
import NewFeature from '../../../../../images/jira-icons/new-feature.svg';
import Task from '../../../../../images/jira-icons/task.svg';
interface typeMappingProps{
  [key: string]: string,
}
const typeIconMapping:typeMappingProps = {
  bug: Bug,
  epic: Epic,
  improvement: Improvement,
  'new feature': NewFeature,
  task: Task,
  "sub-task": Task,
  subtask: Task,
  story: Epic,
}

interface JiraIssueIconProps{
  type: string,
  hideName?: boolean,
  data?: any,
}

const JiraIssueIcon = ({ type, data, hideName }:JiraIssueIconProps) => {
  let iconUrl = typeIconMapping[type.toLowerCase()];
  if (data && data.iconUrl) {
    iconUrl = data.iconUrl;
  }
  return (
    <div>
      <img height={24} width={24} src={iconUrl} alt={`Jira ${type} icon`} />
      {!hideName && <span style={{ paddingLeft: 5, verticalAlign: 'middle'}}>{type}</span>}
    </div>
  )
}

export default JiraIssueIcon;